/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ComponentManagerFn } from '../../registry/Component.type';
import { baseComponentManager } from '../../registry/Components';
import { defaultValue } from './ToolbarDivider';

const ToolbarDividerManager: ComponentManagerFn<'ToolbarDivider'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'ToolbarDivider'>(platform, 'ToolbarDivider'),
    type: 'ToolbarDivider',
    name: 'Toolbar Divider',
    defaultValue,
    props: {},
    category: 'Toolbar',
    getDisplayText: () => '',
    noOverlay: true,
    icon: { iconName: 'grip-lines-vertical' },
    description: `**Overview**<br/>
The Toolbar Divider is a purely visual component used within a Toolbar to separate groups of related items. It typically renders as a thin vertical line.
Use this component to organize a busy toolbar by visually partitioning controls, such as separating navigation links from user account actions.

**1. Configuration**<br/>
* **Zero Configuration:** This component requires no properties (props: {}). It simply inserts a standard vertical separator that matches the application's theme.

**2. Best Use Cases**<br/>
* **Action Groups:** Separating "Edit" tools (Cut, Copy, Paste) from "View" tools (Zoom In, Zoom Out).
* **Header Layout:** Placing a divider between the main navigation links and the search bar.
* **User Controls:** Separating the "Notifications" bell icon from the "User Profile" avatar.`,
  };
};

export default ToolbarDividerManager;
